import { SvgFactory } from '../../Svg';

const CrossedBellIcon = SvgFactory(
    <svg xmlns='http://www.w3.org/2000/svg' width='33' height='32' viewBox='0 0 33 32' fill='black'>
        <path d='M15.5733 29C17.0399 29 18.2399 27.8 18.2399 26.3333H12.9066C12.9066 27.8 14.0933 29 15.5733 29ZM23.5733 14.3333C23.5733 10.24 21.3866 6.81333 17.5733 5.90667V5C17.5733 3.89333 16.6799 3 15.5733 3C14.4666 3 13.5733 3.89333 13.5733 5V5.90667C13.2533 5.98667 12.9466 6.10667 12.6533 6.21333L23.5733 17.1333V14.3333ZM6.78662 4.13333L4.90662 6.01333L8.65328 9.76C7.95995 11.0933 7.57328 12.64 7.57328 14.3333V21L5.85328 22.72C5.01328 23.56 5.59995 25 6.78662 25H23.8933L26.2133 27.32L28.0933 25.44L6.78662 4.13333Z' />
    </svg>,
);

export default CrossedBellIcon;
